export default __webpack_public_path__ + "static/media/roboost.2f5939b8.png";